import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { 
  Home, 
  About, 
  WhatWeDo,
  OurManagement,
  Partnerships,
  Contact, 
  NotFound, 
  WaterTreatmentPlants, 
  SanyolWtSpecilityChemicals,
  DesignAndConsultancy,
  OperationAndMaintenance,
  RevampingOfWaterTreatmentPlants,
  WastewaterTreatmentSolutions,
  HeavyIndustries,
  RawWaterPreTreatment,
  MultiGradeFiltersMgf,
  ActivatedCarbonFiltersAcf,
  MixedBedUnitsMb,
  UltraFiltrationUfPlants,
  ReverseOsmosisRoPlants,
  DesalinationPlants,
  ElectrodeionizationEdi,
  EffluentTreatmentPlantsEtps,
  SewageTreatmentPlantsStps,
  SbrSequentialBatchReactor,
  MultistageRoSeawaterRoRecycling,
  MultiEffectEvaporatorMeeAgitatedThinFilmDryerAtfd,
  DesigningOfIndustrialProcessPiping,
  PipelineLaying,
  CoolingTowersEngineeringConstruction,
  DairyPlants,
  ChemicalPlantsReactorSystems,
  BOOBuildOwnOperateProjects
} from '../pages';

import { EtpStpChemicals, RoAntiscalants, MunicipalWtpStpCetps, 
  IndustrialWaterTreatmentPlants, IndustrialWastewaterTreatmentPlants, 
  ManpowerSupply, AmcOfWaterWastewaterTreatmentPlants, WaterTreatmentPlantsRevamping,
   EtpStpUpgradation, TechnologyUpgradation, CapacityEnhancement, BoilerWaterTreatment, CoolingWaterTreatment } from '../pages/products';

const AppRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/what-we-do" element={<WhatWeDo />} />
      <Route path="/our-management" element={<OurManagement />} />
      <Route path="/partnerships" element={<Partnerships />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/products/etp-stp-chemicals" element={<EtpStpChemicals />} />
      <Route path="/products/ro-antiscalants" element={<RoAntiscalants />} />
      <Route path="/products/municipal-wtp-stp-cetps" element={<MunicipalWtpStpCetps />} />
      <Route path="/products/industrial-water-treatment-plants" element={<IndustrialWaterTreatmentPlants />} />
      <Route path="/products/industrial-wastewater-treatment-plants" element={<IndustrialWastewaterTreatmentPlants />} />
      <Route path="/products/manpower-supply" element={<ManpowerSupply />} />
      <Route path="/products/amc-of-water-wastewater-treatment-plants" element={<AmcOfWaterWastewaterTreatmentPlants />} />
      <Route path="/products/water-treatment-plants-revamping" element={<WaterTreatmentPlantsRevamping />} />
      <Route path="/products/etp-stp-upgradation" element={<EtpStpUpgradation />} />
      <Route path="/products/technology-upgradation" element={<TechnologyUpgradation />} />
      <Route path="/products/capacity-enhancement" element={<CapacityEnhancement />} />
      <Route path="/water-treatment-plants" element={<WaterTreatmentPlants />} />
      <Route path="/sanyol-wt-specility-chemicals" element={<SanyolWtSpecilityChemicals />} />
      <Route path="/design-and-consultancy" element={<DesignAndConsultancy />} />
      <Route path="/operation-and-maintenance" element={<OperationAndMaintenance />} />
      <Route path="/revamping-of-water-treatment-plants" element={<RevampingOfWaterTreatmentPlants />} />
      <Route path="/wastewater-treatment-solutions" element={<WastewaterTreatmentSolutions />} />
      <Route path="/heavy-industries" element={<HeavyIndustries />} />
      <Route path="/raw-water-pre-treatment" element={<RawWaterPreTreatment />} />
      <Route path="/multi-grade-filters-mgf" element={<MultiGradeFiltersMgf />} />
      <Route path="/activated-carbon-filters-acf" element={<ActivatedCarbonFiltersAcf />} />
      <Route path="/mixed-bed-units-mb" element={<MixedBedUnitsMb />} />
      <Route path="/ultra-filtration-uf-plants" element={<UltraFiltrationUfPlants />} />
      <Route path="/reverse-osmosis-ro-plants" element={<ReverseOsmosisRoPlants />} />
      <Route path="/desalination-plants" element={<DesalinationPlants />} />
      <Route path="/electrodeionization-edi" element={<ElectrodeionizationEdi />} />
      <Route path="/effluent-treatment-plants-etps" element={<EffluentTreatmentPlantsEtps />} />
      <Route path="/sewage-treatment-plants-stps" element={<SewageTreatmentPlantsStps />} />
      <Route path="/sbr-sequential-batch-reactor" element={<SbrSequentialBatchReactor />} />
      <Route path="/multistage-ro-seawater-ro-recycling" element={<MultistageRoSeawaterRoRecycling />} />
      <Route path="/multi-effect-evaporator-mee-agitated-thin-film-dryer-atfd" element={<MultiEffectEvaporatorMeeAgitatedThinFilmDryerAtfd />} />
      <Route path="/designing-of-industrial-process-piping" element={<DesigningOfIndustrialProcessPiping />} />
      <Route path="/pipeline-laying" element={<PipelineLaying />} />
      <Route path="/cooling-towers-enc" element={<CoolingTowersEngineeringConstruction />} />
      <Route path="/dairy-plants" element={<DairyPlants />} />
      <Route path="/chemical-plants-reactor-systems" element={<ChemicalPlantsReactorSystems />} />
      <Route path="/boo-build-own-operate-projects" element={<BOOBuildOwnOperateProjects />} />
      <Route path="/boiler-water-treatment" element={<BoilerWaterTreatment />} />
      <Route path="/cooling-water-treatment" element={<CoolingWaterTreatment />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AppRoutes;
